<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Settlement Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Academic Year"
                        outlined
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="gateway"
                        :items="gateway_list"
                        item-text="name"
                        item-value="id"
                        label="Payment Gateway"
                        outlined
                        persistent-hint
                        hint="Please Select Payment Gateway"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                dense
                                v-model="selected_date"
                                v-bind="attrs"
                                v-on="on"
                                prepend-icon="event"
                                hint="This Date Is Inclusive"
                                persistent-hint
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="2" md="3">
                    <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                    <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                dense
                                v-model="to_date"
                                v-on="on"
                                v-bind="attrs"
                                prepend-icon="event"
                                hint="This Date Is Exclusive"
                                persistent-hint
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="todate" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="2" md="2" class="pt-8 pl-2">
                    <v-btn color="primary" @click="fetchSettlementReport()"> Fetch </v-btn>
                </v-col>
            </v-row>
            <div id="my-table-id">
                <v-data-table
                    v-if="arrayList!=''"
                    :headers="headers"
                    @current-items="getFiltered"
                    :items-per-page="-1"
                    :items="bookList1"
                    dense
                    sort-by=""
                    class="elevation-1 mytable"
                    :search="search"
                    fixed-header
                    height="500px"
                >
                    <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete
                                                        class="mr-2 pb-5 pt-2"
                                                        flat
                                                        hide-details
                                                        small
                                                        rounded
                                                        dense
                                                        outlined
                                                        color="#0F2027"
                                                        :label="header.text"
                                                        multiple
                                                        clearable
                                                        :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"
                                                    ></v-autocomplete>
                                                </span>
                                            </span>
                                            <v-btn
                                                class="ma-2 no-display"
                                                rounded
                                                color="success"
                                                outlined
                                                @click="fnExcelReport('my-table-id', 'settlementreport')"
                                                :loading="loader"
                                                ><v-icon color="success">mdi-export</v-icon>Export</v-btn
                                            >
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                    <template v-slot:item.learner_choice="{ item }">
                        <!-- <v-row dense justify="center" v-for="p,index in item.learner_choice" key="index">
                        <strong>{{ p.pno }}</strong> {{ p.course }} -->
                        <v-simple-table dense class="elevation-1">
                            <thead>
                                <tr>
                                    <th>Pre. No.</th>
                                    <th>Subject / Group</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(p, index) in item.learner_choice" :key="index">
                                    <td>{{ p.pno }}</td>
                                    <td>{{ p.course }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <!-- </v-row> -->
                    </template>
                    <template v-slot:body.append>
                        <tr class="total-row">
                            <td :colspan="headers.length - 1" class="text-right total-cell">
                                <strong>Total</strong>
                            </td>
                            <td class="total-cell">
                                <strong>{{ totalAmount }}</strong>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import { stream } from "xlsx";
    export default {
        components: {
            Breadcrumbs,
        },

        data() {
            return {
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                overlay: false,
                stream: null,
                category: null,
                arrayList: [],
                filterArr: [],
                gateway_list: [],
                gateway: null,
                to_date: "",
                date: new Date().toISOString().substr(0, 10),
                menu1: false,
                menu2: false,
                todate: new Date().toISOString().substr(0, 10),
                nowDate: new Date().toISOString().slice(0, 10),
                filters: {
                    order_id: [],
                    transaction_id: [],
                    studentname: [],
                    request_transaction_date: [],
                    settlement_date: [],
                },
                headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Order Id", value: "order_id" },
                    { text: "Transaction Id", value: "transaction_id" },
                    { text: "Application Number", value: "application_number" },
                    { text: "PRN", value: "prn" },
                    { text: "Student Name", value: "studentname" },
                    { text: "Email", value: "email" },
                    { text: "Mobile", value: "mobile" },
                    { text: "Standard", value: "standard" },
                    { text: "Division", value: "division" },
                    { text: "Payment Type", value: "paymenttype" },
                    { text: "Transaction Date", value: "creation_date" },
                    { text: "Settlement Date", value: "settlement_date" },
                    { text: "Amount", value: "ammount" },
                ],
            };
        },
        computed: {
            bookList1() {
                return this.arrayList.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
            totalAmount() {
                return this.bookList1
                    .reduce((sum, item) => sum + (parseFloat(item.ammount) || 0), 0)
                    .toFixed(2);
            },
        },

        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.arrayList.map((d) => d[val]);
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async fetchSettlementReport() {
                this.overlay = true;
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    gateway: this.gateway,
                    date: this.selected_date,
                    todate: this.to_date,
                };
                try {
                    const res = await axios.post("/AccountingAndFeesReports/fetchSettlementReport", data);
                    if (res.data.flag == "YES") {
                        this.arrayList = res.data.arrayList;
                        if (this.arrayList.length == 0) {
                            this.showSnackbar("#b71c1c", "No Data Found....");
                        }
                        this.overlay = false;
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        console.log(res.data);
                        this.ay_std_div_list = res.data.data;
                        this.gateway_list = res.data.gateway_list;
                        this.sel_ay_data = res.data.sel_ay_data;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
    //         fnExcelReport(id, name) {
    //             let tab_text = `<table border='1px'>
    // <tr>
    //   <th>SR. No.</th>
    //   <th>Order Id</th>
    //   <th>Application Number</th>
    //   <th>PRN</th>
    //   <th>Student Name</th>
    //   <th>Email</th>
    //   <th>Mobile</th>
    //   <th>Standard</th>
    //   <th>Division</th>
    //   <th>Standard</th>
    //   <th>Payment Type</th>
    //   <th>Settlement Date</th>
    //   <th>Amount</th>
     
    // </tr>`;

    //             this.arrayList.forEach((s, index) => {
    //                 tab_text += `
    // <tr>
    //     <td>${index + 1}</td>
    //     <td>${s.order_id}</td>
    //     <td>${s.application_number}</td>
    //     <td>${s.prn}</td>
    //     <td>${s.studentname}</td>
    //     <td>${s.email}</td>
    //     <td>${s.mobile}</td>
    //     <td>${s.standard}</td>
    //     <td>${s.division}</td>
    //     <td>${s.paymenttype}</td>
    //     <td>${s.creation_date}</td>
    //     <td>${s.settlement_date}</td>
    //     <td>${s.ammount}</td>
    //   </tr>`;
    //             });

    //             tab_text += "</table>";

    //             const blob = new Blob([tab_text], {
    //                 type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //             });
    //             const filename = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

    //             if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //                 // For IE
    //                 window.navigator.msSaveOrOpenBlob(blob, filename);
    //             } else {
    //                 // For modern browsers
    //                 const url = window.URL.createObjectURL(blob);
    //                 const a = document.createElement("a");
    //                 a.href = url;
    //                 a.download = filename;
    //                 a.click();
    //                 window.URL.revokeObjectURL(url);
    //             }
    //         },
            fnExcelReport(id, name) {
                let tab_text = `<table border='1px'>
                <tr>
                <th>SR. No.</th>
                <th>Order Id</th>
                <th>Transaction Id</th>
                <th>Application Number</th>
                <th>PRN</th>
                <th>Student Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Standard</th>
                <th>Division</th>
                <th>Standard</th>
                <th>Payment Type</th>
                <th>Settlement Date</th>
                <th>Amount</th>
                
                </tr>`;

                    let total = 0;

                    this.arrayList.forEach((s, index) => {
                        total += parseFloat(s.ammount) || 0;
                        tab_text += `
                <tr>
                    <td>${index + 1}</td>
                    <td>${s.order_id}</td>
                    <td>${s.transaction_id}</td>
                    <td>${s.application_number}</td>
                    <td>${s.prn}</td>
                    <td>${s.studentname}</td>
                    <td>${s.email}</td>
                    <td>${s.mobile}</td>
                    <td>${s.standard}</td>
                    <td>${s.division}</td>
                    <td>${s.paymenttype}</td>
                    <td>${s.creation_date}</td>
                    <td>${s.settlement_date}</td>
                    <td>${s.ammount}</td>
                </tr>`;
                    });

                    tab_text += `
                <tr>
                    <td colspan="12" align="right"><b>Total</b></td>
                    <td><b>${total.toFixed(2)}</b></td>
                </tr>`;

                tab_text += "</table>";

                const blob = new Blob([tab_text], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const filename = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
        },
        mounted() {
            this.onload();
            this.selected_date = this.formatDate(this.date);
            this.to_date = this.formatDate(this.todate);
        },
        watch: {
            date(val) {
                this.selected_date = this.formatDate(this.date);
            },
            todate(val) {
                this.to_date = this.formatDate(this.todate);
            },
        },
    };
</script>
<style scoped>
.mytable >>> .total-row .total-cell {
    height: 56px !important;
    padding: 12px 16px !important;
    font-size: 15px;
    background: #f5f5f5;
    /* border-top: 2px solid #999; */
    bottom: 0;
    z-index: 2;
}
</style>
